import { ApprovalStatus } from "../../../../apps/containers/AppContainer/ApprovalsContainer/ApprovalsStatus";
import ScreenHelpers from "../../../../apps/data/screen/ScreenHelpers";
import { TransformedAIReview, TransformedApproval } from "../../../model/transform";
import { createSortByDate, sortBy } from "../../../utils/sortBy";

export type TransformedReview = TransformedApproval | TransformedAIReview;

export function isTransformedAIReview(review: TransformedReview): review is TransformedAIReview {
    return !isTransformedApproval(review);
}

export function isTransformedApproval(review: TransformedReview): review is TransformedApproval {
    return typeof review.screens[0] === "string";
}

export function sortAndGroupReviews(approvals: TransformedReview[]) {
    const forMyReview: TransformedReview[] = [];
    const createdByMe: TransformedReview[] = [];
    const approved: TransformedReview[] = [];
    const others: TransformedReview[] = [];
    const sortedApprovals = approvals.sort(createSortByDate(({ updatedAt, createdAt }) => (updatedAt || createdAt)));

    for (const approval of sortedApprovals) {
        if (approval.review.status === ApprovalStatus.APPROVED) {
            approved.push(approval);
            continue;
        }

        if (isTransformedApproval(approval) && approval.review.reviewedBy?._id === Zeplin.user._id) {
            forMyReview.push(approval);
            continue;
        }

        if (approval.requestedBy?._id === Zeplin.user._id) {
            if (isTransformedApproval(approval)) {
                const screens = ScreenHelpers.getScreens({ pid: approval.project, sids: approval.screens });
                const isReRequestable = Boolean(approval.review.reviewedBy &&
                    approval.review.status === ApprovalStatus.CHANGES_REQUESTED &&
                    screens?.some(screen => screen.updated > approval.review.reviewedAt!));

                createdByMe.push({
                    ...approval,
                    isReRequestable
                });
            } else {
                createdByMe.push({
                    ...approval,
                    isReRequestable: false
                });
            }

            continue;
        }

        others.push(approval);
    }

    if (createdByMe.length) {
        createdByMe
            .sort(({ createdAt: firstDate }, { createdAt: secondDate }) => (
                sortBy.created({ created: firstDate }, { created: secondDate })
            ))
            .sort(a => (a.isReRequestable ? -1 : 1));
    }

    return {
        forMyReview,
        createdByMe,
        approved,
        others
    };
}
